import { render, staticRenderFns } from "./PayslipModal.vue?vue&type=template&id=f2595fe8&scoped=true&"
import script from "./PayslipModal.vue?vue&type=script&setup=true&lang=js&"
export * from "./PayslipModal.vue?vue&type=script&setup=true&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f2595fe8",
  null
  
)

export default component.exports